import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { component } from 'picoapp';
import { ReactDrawer } from '../parts';
import { useMount } from 'ahooks';
import { motion, AnimatePresence } from 'framer-motion';
import classnames from 'classnames';
import { slugify } from '@utils';

const MenuItem = ({ link, level, showImage, path }) => {
  const [isOpen, setIsOpen] = useState(false);
  const optionClasses = classnames('Nav__item', `level-${level}`, {
    'is-active': link.active,
  });

  const handleClick = (e) => {
    if (link.links && level < 2) {
      e.preventDefault();
      setIsOpen(!isOpen);
    }
  };

  return (
    <div className={optionClasses}>
      <motion.a initial={false} onClick={handleClick} href={link.url} className={`Nav__link level-${level}`}>
        {showImage && level > 2 && (
          <figure>
            <img src={`${window.__webpack_public_path__}${path}.jpg`} alt={link.title} loading="lazy" />
          </figure>
        )}
        <span>{link.title}</span>
      </motion.a>
      {link.links && (
        <AnimatePresence initial={false}>
          {isOpen && (
            <motion.div
              key="content"
              initial="collapsed"
              animate="open"
              exit="collapsed"
              variants={{
                open: { opacity: 1, height: 'auto' },
                collapsed: { opacity: 0, height: 0 },
              }}
              transition={{ duration: 0.6, ease: [0.04, 0.62, 0.23, 0.98] }}
            >
              {level < 2 && <SubMenu items={link.links} parent={link} level={level} showImage={showImage} path={path}></SubMenu>}
            </motion.div>
          )}
        </AnimatePresence>
      )}
    </div>
  );
};

const SubMenu = ({ items, level, parent, showImage, path }) => {
  return (
    <div className={`Nav__submenu level-${level}`} data-identifier={parent.object_handle}>
      {items.map((link, index) => {
        return (
          <MenuItem link={link} level={level + 1} key={link.title} showImage={showImage} path={`${path}_${slugify(link.title)}`}></MenuItem>
        );
      })}
    </div>
  );
};

const MobileNav = ({ parentNode }) => {
  const [showDrawer, setShowDrawer] = useState(false);
  const [primaryMenu, setPrimaryMenu] = useState({ title: '', links: [] });
  const [secondaryMenu, setSecondaryMenu] = useState({ title: '', links: [] });
  const [customer, setCustomer] = useState();

  useMount(() => {
    let contentTag = parentNode.nextElementSibling;
    try {
      let menuData = JSON.parse(contentTag.innerText);

      // primary menu
      let menuKey = Object.keys(menuData['primary'])[0];
      setPrimaryMenu(menuData['primary'][menuKey]);

      // secondart menu
      let menuSecKey = Object.keys(menuData['secondary'])[0];
      setSecondaryMenu(menuData['secondary'][menuSecKey]);

      // customer
      // setCustomer(menuData['customer']);
    } catch (error) {
      console.log(error);
    }
  });

  const { links } = primaryMenu;
  const sec_links = secondaryMenu.links;

  return (
    <>
      <button className="Button mobile-toggler" data-layout="noLayout" onClick={() => setShowDrawer(!showDrawer)}>
        <svg className="icon icon--primary" height="1em" viewBox="0 0 20 20" width="1em" aria-hidden="true" role="presentation">
          <use xlinkHref="#menu"></use>
        </svg>
        <span className="screen-reader-text">Menu</span>
      </button>
      <ReactDrawer className="mobileNav" showDrawer={showDrawer} setShowDrawer={setShowDrawer} position={'left'}>
        <header>
          <button type="button" className="Button" data-layout="noLayout" onClick={() => setShowDrawer(!showDrawer)}>
            <svg className="icon " height="1em" viewBox="0 0 20 20" width="1em" aria-hidden="true" role="presentation">
              <use xlinkHref="#close"></use>
            </svg>
          </button>
        </header>
        <div className="Nav Nav--mainMobile Nav--vertical">
          {links.map((link, index) => {
            return <MenuItem link={link} level={1} key={link.title} showImage={link.title === 'Bags'} path={link.object_handle}></MenuItem>;
          })}
        </div>
        <div className="Nav Nav--secMobile  Nav--vertical">
          {sec_links.map((link, index) => {
            return <MenuItem link={link} level={1} key={link.title} path={link.object_handle} image={link.image ? link.image : null}></MenuItem>;
          })}
        </div>
      </ReactDrawer>
    </>
  );
};

export default component((node, ctx) => {
  const element = <MobileNav ctx={ctx} parentNode={node} />;
  ReactDOM.render(element, node);
});
